<template>
  <input :id="field.name" :name="field.name" type="text" class="form-control" readonly="readonly">
</template>

<script>
export default {
  props: {
    field: {
      type: Object,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
  },

  setup() {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// SystemIdRender.vue?14c78846